import { FC } from 'react';

export const Edit: FC = (props) => (
	<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M16.3787 2.70705C17.5503 1.53548 19.4497 1.53548 20.6213 2.70705L21.2929 3.37862C22.4645 4.5502 22.4645 6.44969 21.2929 7.62126L7.20711 21.7071C7.01957 21.8946 6.76522 21.9999 6.5 21.9999H3C2.44772 21.9999 2 21.5522 2 20.9999V17.4999C2 17.2347 2.10536 16.9804 2.29289 16.7928L16.3787 2.70705ZM19.2071 4.12126C18.8166 3.73074 18.1834 3.73074 17.7929 4.12126L16.6642 5.24994L18.75 7.33573L19.8787 6.20705C20.2692 5.81652 20.2692 5.18336 19.8787 4.79284L19.2071 4.12126ZM17.3358 8.74994L15.25 6.66416L4 17.9142V19.9999H6.08579L17.3358 8.74994Z"
			fill="currentColor"
		/>
	</svg>
);
